<template>
  <div class="banksolutionMain">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>行业痛点</li>
              </ul>
            </div>
            <div class="solutionList">
                <ul v-if="difficultList.length>0">
                  <li v-for="item in difficultList">
                      <div><img :src="item.img"></div>
                      <dl>
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                      </dl>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>解决方案</li>
                </ul>
              </div>
              <div class="programBox">
                  <div class="programBoxHead">
                      <ul v-if="bankSoluList.length>0">
                        <li v-for="item in bankSoluList">
                            <img :src="item.img" alt="">
                            <p>{{item.title}}</p>
                        </li>
                      </ul>
                  </div>
                  <div class="programBoxCon">
                      <p>
                        在银行业，智签电子签约平台可针对于业务流程信息化、传统金融业务互联网化与电子数据存证上链等场景为用户赋能，从而提升效率，帮助客户将传统金融业务向着互联网+方向迈进，并利用司法联盟链保证电子数据的原始性、真实性与合法性。
                      </p>
                      <p>
                        业务流程信息化方面，智签电子签约平台可为银行客户提供相应的签名接口，将部分需要终端用户签字的地方用电子签名代替，如用户开卡签字，《征信授权书》的签署，部分业务申请书的签署等。《中华人民共和国电子签名法》明确规定：可靠的电子签名与手写签名或者盖章具有同等的法律效力。采用电子签名，不仅可以提升效率，还能大大减少纸质文档的产生，降低客户的文件管理成本，助力绿色环保。
                      </p>
                      <p>
                        金融+互联网方面，随着互联网、移动互联网的发展，人们的金融服务使用习惯在逐渐的升级改变，小微贷款、信用贷款、消费金融、互联网理财等新业务已经成为银行业发展的新增长点，网银、手机银行等应用被大量使用，在此过程中，应用流程复杂、用户体现差已经成为行业内的主要痛点。智签电子签约平台可为银行用户提供基于电子合同签署的全方位服务，通过技术手段的运用，固化实名认证、合同签署、履约执行等整个业务流程中的电子数据并进行存证，保障电子数据的真实性原始性，并利用区块链技术通过司法联盟链将数据同步至多家公证处、司法鉴定机构、仲裁机构以及互联网法院，保证电子数据可以作为证据被法院、仲裁所采信。
                      </p>
                      <p>
                        电子数据上链方面，对于银行的手机银行系统、网上银行系统、微信公众号、H5页面等业务流程中产生的所有电子数据，可通过智签电子数据平台的接口进行上链存证，保障电子数据的原始性、真实性与合法性。
                      </p>
                  </div>
              </div>

            </div>
          </div>
           <div class="solttionConItem">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>特色保障</li>
                </ul>
              </div>
              <div class="guaranteeList">
                <ul>
                  <li v-for="item in guaranteeList">
                    <div>
                        <img :src="item.img" class="BigImg">
                        <span class="icon" v-bind:style="{backgroundImage:'url(' + item.icon + ')'}"></span>
                    </div>
                    <dl>
                      <dt><span>{{item.title}}</span></dt>
                      <dd>{{item.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      difficultList:[
        {
          img:require("../../../assets/images/solution/hlwkn_icon.png"),
          title:"互联网化困难",
          content:"商业银行正在运用互联网思维，推进理财、信贷、支付等产品互联网化，传统银行业互联网化困难。"
        },
        {
          img:require("../../../assets/images/solution/htqsn_icon.png"),
          title:"合同签署难",
          content:"传统模式线下现场的合同签署的模式难以满足业务互联网化的用户体验需求。"
        },
        {
          img:require("../../../assets/images/solution/wjgln_icon.png"),
          title:"文件管理难",
          content:"大量的纸质合同或者纸质文件，存储成本高，安全性差，管理困难。"
        },
        {
          img:require("../../../assets/images/solution/dzsjkx_icon.png"),
          title:"电子数据可信",
          content:"电子数据易篡改，易丢失，产生纠纷时难以自证说清，容易被质疑。"
        }
      ],
      guaranteeList:[
        {
          img:require("../../../assets/images/solution/legal_img.png"),
          icon:require('../../../assets/images/solution/legal_nor_icon.png.png'),
          title:"法律效力",
          content:"对接公安部、工商局、银联数据库进行实名认证，保障合同主体可信，采用数字证书，可信时间源等方式，保障合同司法效力。"
        },
        {
          img:require("../../../assets/images/solution/jbzx_img.png"),
          icon:require('../../../assets/images/solution/jdcb_nor_icon.png'),
          title:"降本增效",
          content:"减少线下签署环节，减少人力、邮寄、纸质合同及管理成本。达到大幅度提高人力资源管理工作的效率并降低成本的目的。"
        },
        {
          img:require("../../../assets/images/solution/judicial_img.png"),
          icon:require('../../../assets/images/solution//judicial_nor_icon.png'),
          title:"司法保障",
          content:"司法联盟链同步至多家公证处、司法鉴定机构，仲裁机构以及互联网法院，多方参与共识，保证电子数据作为证据的司法证明能力。"
        },
        {
          img:require("../../../assets/images/solution/data_img.png"),
          icon:require('../../../assets/images/solution/data_nor_icon.png.png'),
          title:"数据安全",
          content:"采用杂凑算法、非对称加密算法、分布式存储、区块链技术等多种技术保障电子数据的真实性、安全性及不可篡改。"
        },
      ],
      bankSoluList:[
        {
          img:require("../../../assets/images/solution/lcxxh_icon.png"),
          title:"流程信息化"
        },
        {
          img:require("../../../assets/images/solution/jraddhlw_icon.png"),
          title:"金融+互联网"
        },
        {
          img:require("../../../assets/images/solution/sjczgj_icon.png"),
          title:"数据存证上链"
        }
      ]
    }
  }
}
</script>
<style lang="scss" >
.banksolutionMain{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
      padding-bottom:40px;
       margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .solutionList{
          width:100%;
          height: 190px;
          li{
            width: calc((100% - 60px) / 4);
            height: 190px;
            float: left;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-right: 20px;
            padding:20px;
            box-sizing: border-box;
            border: 1px solid rgb(235,235,235);
            div{
              text-align: right;
              img{
                width:48px;
                height: auto;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-bottom: 10px;
              }
              dd{
                font-size: 13px;
                color: #787878;
                line-height: 19px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
             border-color: #fff;
          }
        }
        .programBox{
          width:100%;
          overflow: hidden;
          .programBoxHead{
            width: 100%;
            height: 144px;
            ul{
              width:100%;
              height: 100%;
              display: flex;
              justify-content: space-around;
              align-items: center;
              li{ 
                text-align:center;
                img{
                  width:60px;
                  height: auto;
                  margin-bottom: 12px;
                }
                p{
                 font-size: 18px;
                  color: #787878; 
                }
              }
            }
          }
          .programBoxCon{
            p{
              font-size: 14px;
              color:#787878;
              line-height: 26px;
              text-indent: 2em;
              text-align: justify;
              margin-bottom: 20px;
            }
          }
        }
        .solttionConpor{
          max-width: 1180px;
          margin:0 auto;
        }
        .guaranteeList{
          width:100%;
          height: 328px;
          li{
            width: calc((100% - 78px) / 4);
            height: 328px;
            float: left;
            margin-right: 26px;
            box-sizing: border-box;
            padding:2px;
            border: 1px solid rgb(235,235,235);
            div{
              width:100%;
              height: 160px;
              position: relative;
              .BigImg{
                width:100%;
                height: 100%;
              }
              .icon{  
                position: absolute;
                top:50%;
                left:50%;
                margin-top:-19px;
                margin-left: -20px;
                width:40px;
                height: 38px;
                background-size:100% 100%;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-top:11px;
                margin-bottom: 15px;
                text-align: center;
                span{
                  display: inline-block;
                  padding-bottom:6px;
                  border-bottom: 2px solid #B4B4B4;
                }
              }
              dd{
                box-sizing: border-box;
                padding:0 16px;
                font-size: 14px;
                color: #787878;
                line-height: 21px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
            border-color: #fff;
            dl dt span{
              border-color:#686868;
            }
          }
          li:nth-child(1):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/legal_hov_icon.png')!important;
            }
          }
          li:nth-child(2):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/jdcb_hov.png')!important;
            }
          }
          li:nth-child(3):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/judicial_hov_icon.png.png')!important;
            }
          }
          li:nth-child(4):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/data_hov_icon.png')!important;
            }
          }
        }
      }
      .solttionConItem:nth-child(2){
        width: 100%;
        background: #F3F2F2;
      }
    }
  }
</style>
